import React, { useRef, useState } from 'react';
import Loader from '../../components/Loader';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import { BOOKMARKS, LIKEDPOSTS, PURCHASEDPOSTS, SAVED_POSTS, SUBSCRIBERS, SUBSCRIPTIONS } from '../../constants/routes';

const Lists = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ background: '#fff', minHeight: '100%' }}>
      <div style={{ maxWidth: 400 }}>
        <Loader isLoadin={isLoading}>
          <Link to={SUBSCRIBERS} className="lists-link">
            {t('Subscribers')}
          </Link>
          <Link to={SUBSCRIPTIONS} className="lists-link">
            {t('Subscriptions')}
          </Link>
          <Link to={LIKEDPOSTS} className="lists-link">
            {t('Liked Posts')}
          </Link>
          <Link to={SAVED_POSTS} className="lists-link">
            {t('Saved posts')}
          </Link>
          <Link to={PURCHASEDPOSTS} className="lists-link">
            {t('Purchased Posts')}
          </Link>
        </Loader>
      </div>
    </div>
  );
};

export default Lists;
